module.exports = __webpack_public_path__ + "img/PHP.ef979872.png";